import { render } from "./UboCompany.vue?vue&type=template&id=e13af888&scoped=true"
import script from "./UboCompany.vue?vue&type=script&lang=js"
export * from "./UboCompany.vue?vue&type=script&lang=js"

import "./custom-ubo.scss?vue&type=style&index=0&id=e13af888&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e13af888"]])

export default __exports__